// Copyright Prashant Vaghela, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import React from 'react';
import { createRoot } from 'react-dom/client';

import { applyTheme } from '@cloudscape-design/components/theming';

import { Distribution } from '../../fake-server/types';
import { customTheme as theme } from '../../styles/theme';
import DataProvider from '../commons/data-provider';
import { App } from './root';

import '../../styles/base.scss';

const { reset } = applyTheme({ theme });
if (!reset) {
  /* empty */
}

const dataProvider = new DataProvider();

dataProvider.getData<Distribution>('distributions').then(distributions => {
  createRoot(document.getElementById('app')!).render(<App distributions={distributions} />);
});
